import React from 'react';
import { CounterContainer, Count, Caption } from '@@Components/Counter/styled';
export const Counter = ({ count, caption, }) => {
    return (React.createElement(CounterContainer, null,
        React.createElement(Count, null, count),
        React.createElement(Caption, null, caption)));
};
